import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import jsDig from "utils/jsDig";
import { capitalize } from "lodash";
import showAlert from 'utils/showAlert';

export default function LiteAlerts(props) {
  let chevronDown = require("images/lite/icons/chevron-down.png");
  chevronDown = <img className="lite-chevron-down" src={`/datapulse${chevronDown}`} />;
  const authenticityToken = document.querySelector('meta[name="csrf-token"]').content;

  const [searchTerm, setSearchTerm] = useState("");
  const [clients, setClients] = useState(props.clients);
  const [selectedClient, setSelectedClient] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleViewAlerts = (client) => {
    setSelectedClient(client);
    setShowModal(true);
  };

  const handleResolveAllAlerts = (clientId) => {
    fetch("/datapulse/lite-alerts/resolve-all-alerts", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": authenticityToken,
      },
      body: JSON.stringify({ client_account_id: clientId }),
    })
      .then((response) => response.json())
      .then((data) => {
        showAlert(data.message);
        if (data.success == true) {
          setClients((prevClients) =>
            prevClients.map((client) =>
              client.id === clientId ? { ...client, alerts: [] } : client
            )
          );
          setSelectedClient((prevClient) => ({
            ...prevClient,
            alerts: [],
          }));
        }
      });
  };

  const handleResolveAlert = (alertId) => {
    fetch("/datapulse/lite-alerts/resolve-alert", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": authenticityToken,
      },
      body: JSON.stringify({ alert_id: alertId }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        console.log(data.success == true)
        showAlert(data.message);
        if (data.success == true) {
          setClients((prevClients) =>
            prevClients.map((client) =>
              client.id === selectedClient.id
                ? {
                    ...client,
                    alerts: client.alerts.filter((alert) => alert.id !== alertId),
                  }
                : client
            )
          );
          setSelectedClient((prevClient) => ({
            ...prevClient,
            alerts: prevClient.alerts.filter((alert) => alert.id !== alertId),
          }));
        }
      });
  };

  const filteredClients = clients.filter((client) =>
    client.alerts.length > 0 && client.company_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleToggleDetails = (e) => {
    if (e.target.tagName === "BUTTON") return; // don't toggle details if the user clicked the resolve alert button
    const alertItem = $(e.currentTarget).closest(".alert-item");
    alertItem.find(".alert-details").slideToggle();
    alertItem.find(".alert-toggle-icon img").toggleClass("lite-chevron-down lite-chevron-up");
  };

  return (
    <>
      <div className="standard-page-padding">
        <h1>Alerts</h1>
        <div className="d-flex justify-content-space-between flex-wrap gap-24">
          <div className="d-flex align-items-center gap-24">
            <p style={{ fontSize: "20px" }}>
              <b>Search:</b>
            </p>
            <input
              type="text"
              className="tableSearch lite-input"
              placeholder=""
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
        <div className="account-alerts">
          {filteredClients.length === 0 && <p style={{ marginBottom: "12px" }}>No alerts</p>}
          {filteredClients.map((client) => (
            <div key={client.id} className="alert-row d-flex justify-content-between align-items-center">
              <div class="alert-company-name">
                <b>{client.company_name}</b>
              </div>
              <div class="alert-button-container">
                <div class="alerts-number">{client.alerts.length}</div>
                <button className="button b-type-secondary b-size-small margin-0" onClick={() => handleViewAlerts(client)}>
                  <span>View</span>
                </button>
                <button className="button b-type-secondary b-size-small margin-0" onClick={() => handleResolveAllAlerts(client.id)}>
                  <span>Resolve all</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedClient && (
        <Modal show={showModal} onHide={() => setShowModal(false)} className="client-alerts-modal">
          <Modal.Header closeButton>
            <Modal.Title>
              <h4>Alerts for {selectedClient.company_name}</h4>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedClient.alerts.map((alert, index) => {
              const alertCreatedAt = new Date(alert.created_at).toLocaleString("en-US", { // Convert utc date to local time in this format 12:30 PM, 12/31/2021
                hour: "numeric",
                minute: "numeric",
                hour12: true,
                month: "numeric",
                day: "numeric",
                year: "numeric",
              });
              return (
                <div key={alert.id} className="alert-item">
                  <div className="alert-header d-flex justify-content-between" onClick={handleToggleDetails}>
                    <p className={`alert-title ${alert.emergency && "filter-red"}`}><b>{alert.text}</b></p>
                    <div className="d-flex">
                      <button className="button b-type-secondary b-size-small" onClick={() => handleResolveAlert(alert.id)}>
                        Resolve<span className="desktop-only"> alert</span>
                      </button>
                      <div className="alert-toggle-icon ml-3">
                        {chevronDown}
                      </div>
                    </div>
                  </div>
                  <div className="alert-details" style={{display: "none"}}>
                    <p><b>Type:</b> {alert.alert_type}</p>
                    <p><b>Created At:</b> {alertCreatedAt}</p>
                    {alert.secondary_text && (
                      <div
                        className="alert-secondary-text"
                        dangerouslySetInnerHTML={{ __html: alert.secondary_text }}
                      ></div>
                    )}
                  </div>
                  <hr />
                </div>
              )
            })}
          </Modal.Body>
          <Modal.Footer>
            <button className="button b-type-secondary b-size-normal" onClick={() => setShowModal(false)}>
              Close
            </button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
}
